import { render, staticRenderFns } from "./LeftNavigationMenuHeader.vue?vue&type=template&id=3c0efbe2&"
import script from "./LeftNavigationMenuHeader.vue?vue&type=script&lang=js&"
export * from "./LeftNavigationMenuHeader.vue?vue&type=script&lang=js&"
import style0 from "./LeftNavigationMenuHeader.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem,VListItemContent})
